<template>
  <div>
    <PageHeader :items="items" />
    <validation-observer ref="simpleRules">
      <div class="card">
        <div class="card-body">
          <b-row>
            <!-- <b-col cols="12" lg="6" md="6" class="mb-1">
              <validation-provider
                #default="{ errors }"
                name="Free Test Upper Jaw"
                rules="required"
              >
                <TextInput
                  v-model="form.freeTestUpperTeeth"
                  type="number"
                  :label="$t('Free Test Upper Jaw')"
                  :tooltipMessage="$t('Free Test Upper Jaw')"
                  :required="true"
                  :disabled="!$can(`${$route.meta.permission}.save`)"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-col>
            <b-col cols="12" lg="6" md="6" class="mb-1">
              <validation-provider
                #default="{ errors }"
                name="Free Test Lower Jaw"
                rules="required"
              >
                <TextInput
                  v-model="form.freeTestLowerTeeth"
                  type="number"
                  :label="$t('Free Test Lower Jaw')"
                  :tooltipMessage="$t('Free Test Lower Jaw')"
                  :required="true"
                  :disabled="!$can(`${$route.meta.permission}.save`)"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-col> -->
            <b-col cols="12" lg="6" md="6" class="mb-1">
              <validation-provider
                #default="{ errors }"
                name="Free Cases"
                rules="required"
              >
                <TextInput
                  v-model="form.freeCases"
                  type="number"
                  :label="$t('freeCases')"
                  :tooltipMessage="$t('freeCases')"
                  :required="true"
                  :disabled="!$can(`${$route.meta.permission}.save`)"
                  :error="errors[0]"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-col>
            <b-col cols="12" lg="6" md="6" class="mb-1">
              <validation-provider
                #default="{ errors }"
                name="Sales Partner Free Cases"
                rules="required"
              >
                <TextInput
                  v-model="form.salesPartnerFreeCases"
                  type="number"
                  :label="$t('salesPartnerFreeCases')"
                  :tooltipMessage="$t('salesPartnerFreeCases')"
                  :required="true"
                  :disabled="!$can(`${$route.meta.permission}.save`)"
                  :error="errors[0]"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-col>
            <b-col cols="12" lg="6" md="6" class="mb-1">
              <validation-provider
                #default="{ errors }"
                name="Redirect URL after Registration"
                rules="required"
              >
                <TextInput
                  v-model="form.redirectUrlAfterRegistration"
                  type="text"
                  :required="true"
                  :label="$t('redirectUrlAfterRegistration')"
                  :tooltipMessage="$t('redirectUrlAfterRegistration')"
                  :disabled="!$can(`${$route.meta.permission}.save`)"
                  :error="errors[0]"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-col>
            <b-col cols="12" lg="6" md="6" class="mb-1">
              <validation-provider
                #default="{ errors }"
                rules="required"
                name="Redirect URL after Mail-Verification"
              >
                <TextInput
                  v-model="form.redirectUrlAfterMailVerification"
                  type="text"
                  :required="true"
                  :label="$t('redirectUrlAfterMailVerification')"
                  :tooltipMessage="$t('redirectUrlAfterMailVerification')"
                  :disabled="!$can(`${$route.meta.permission}.save`)"
                  :error="errors[0]"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-col>
            <b-col cols="12" class="mt-2">
              <h3 class="mb-1">Bridge 33-35</h3>
            </b-col>
            <b-col cols="12" lg="6" md="6" class="mb-1">
              <label class="input-label form-label"
                >{{ $t("upperJawTemplate") }}
              </label>
              <div>
                <input
                  type="file"
                  ref="bridgeUpperInput"
                  @change="addFile($event, 'bridgeUpper')"
                  accept=".stl, .obj"
                />
              </div>
              <div v-if="bridgeUpperJaw" class="mt-1">
                <b-button
                  variant="primary"
                  @click="handlePreviewClick('bridgeUpper')"
                >
                  <span>{{ $t("previewUpperJaw") }}</span>
                </b-button>
              </div>
              <div
                v-if="form.bridgeUpperJaw && form.bridgeUpperJaw.name"
                class="cursor-pointer mt-1"
                @click="deleteFile('bridgeUpper')"
              >
                <feather-icon size="16" icon="TrashIcon" style="color: red" />
              </div>
            </b-col>
            <b-col cols="12" lg="6" md="6" class="mb-1">
              <label class="input-label form-label"
                >{{ $t("lowerJawTemplate") }}
              </label>
              <div>
                <input
                  type="file"
                  ref="bridgeLowerInput"
                  @change="addFile($event, 'bridgeLower')"
                  accept=".stl, .obj"
                />
              </div>
              <div v-if="bridgeLowerJaw" class="mt-1">
                <b-button
                  variant="primary"
                  @click="handlePreviewClick('bridgeLower')"
                >
                  <span>{{ $t("previewLowerJaw") }}</span>
                </b-button>
              </div>
              <div
                v-if="form.bridgeLowerJaw && form.bridgeLowerJaw.name"
                class="cursor-pointer mt-1"
                @click="deleteFile('bridgeLower')"
              >
                <feather-icon size="16" icon="TrashIcon" style="color: red" />
              </div>
            </b-col>
            <b-col cols="12" class="mt-2">
              <h3 class="mb-1">Crown 16</h3>
            </b-col>
            <b-col cols="12" lg="6" md="6" class="mb-1">
              <label class="input-label form-label"
                >{{ $t("upperJawTemplate") }}
              </label>
              <div>
                <input
                  type="file"
                  ref="crownUpperInput"
                  @change="addFile($event, 'crownUpper')"
                  accept=".stl, .obj"
                />
              </div>
              <div v-if="crownUpperJaw" class="mt-1">
                <b-button
                  variant="primary"
                  @click="handlePreviewClick('crownUpper')"
                >
                  <span>{{ $t("previewUpperJaw") }}</span>
                </b-button>
              </div>
              <div
                v-if="form.crownUpperJaw && form.crownUpperJaw.name"
                class="cursor-pointer mt-1"
                @click="deleteFile('crownUpper')"
              >
                <feather-icon size="16" icon="TrashIcon" style="color: red" />
              </div>
            </b-col>
            <b-col cols="12" lg="6" md="6" class="mb-1">
              <label class="input-label form-label"
                >{{ $t("lowerJawTemplate") }}
              </label>
              <div>
                <input
                  type="file"
                  ref="crownLowerInput"
                  @change="addFile($event, 'crownLower')"
                  accept=".stl, .obj"
                />
              </div>
              <div v-if="crownLowerJaw" class="mt-1">
                <b-button
                  variant="primary"
                  @click="handlePreviewClick('crownLower')"
                >
                  <span>{{ $t("previewLowerJaw") }}</span>
                </b-button>
              </div>
              <div
                v-if="form.crownLowerJaw && form.crownLowerJaw.name"
                class="cursor-pointer mt-1"
                @click="deleteFile('crownLower')"
              >
                <feather-icon size="16" icon="TrashIcon" style="color: red" />
              </div>
            </b-col>
          </b-row>
        </div>
      </div>
      <div class="d-flex align-items-center justify-content-end">
        <b-button
          variant="primary"
          @click="save"
          class="d-flex align-items-center gap-1"
          :disabled="isFormInvalid"
          v-if="$can(`${$route.meta.permission}.save`)"
        >
          <feather-icon icon="PlusIcon" size="12" />
          <span>{{ $t("saveConfiguration") }}</span>
        </b-button>
      </div>
    </validation-observer>
    <div class="c-modal" v-show="showPreviewModal">
      <div class="c-modal-content">
        <div class="c-modal-header">
          <h3>
            {{
              previewJawType === "upper"
                ? $t("previewUpperJaw")
                : $t("previewLowerJaw")
            }}
          </h3>
          <div class="x-icon" @click="showPreviewModal = false">
            <feather-icon size="16" icon="XIcon" />
          </div>
        </div>
        <div class="c-modal-body">
          <PreviewModel v-if="showPreviewModal" :jaw="showJaw" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from "@/components/PageHeader.vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import TextInput from "@/components/TextInput.vue";
import { mapGetters } from "vuex";
import MultiSelect from "vue-multiselect";
import { required } from "@validations";
import formDirtyMixin from "@/mixins/formDirtyMixin";
import fileHandlerMixin from "@/mixins/fileHandlerMixin";
import PreviewModel from "@/views/global-configuration/components/PreviewModel.vue";
export default {
  components: {
    PageHeader,
    ValidationProvider,
    ValidationObserver,
    TextInput,
    MultiSelect,
    PreviewModel,
  },
  mixins: [fileHandlerMixin, formDirtyMixin],
  data() {
    return {
      form: {
        // freeTestUpperTeeth: "",
        // freeTestLowerTeeth: "",
        freeCases: "",
        salesPartnerFreeCases: "",
        redirectUrlAfterRegistration: "",
        redirectUrlAfterMailVerification: "",
        bridgeUpperJaw: {},
        bridgeLowerJaw: {},
        crownUpperJaw: {},
        crownLowerJaw: {},
      },
      originalForm: null,
      bridgeUpperJaw: "",
      bridgeLowerJaw: "",
      crownUpperJaw: "",
      crownLowerJaw: "",
      showPreviewModal: false,
      showJaw: null,
      previewJawType: null,
    };
  },
  watch: {
    form: {
      handler(newVal) {
        this.isFormDirty = JSON.stringify(newVal) !== this.originalForm;
      },
      deep: true,
    },
  },
  computed: {
    ...mapGetters(["showLoader"]),
    ...mapGetters("globalConfiguration", ["configuration"]),
    items() {
      return [
        {
          text: "Dental Twin",
          to: "/home",
        },
        {
          text: this.$t("registrationConfiguration"),
          active: true,
        },
      ];
    },
    isFormInvalid() {
      return (
        // !this.form.freeTestUpperTeeth ||
        // !this.form.freeTestLowerTeeth ||
        !this.form.freeCases ||
        !this.form.salesPartnerFreeCases
      );
    },
  },
  async mounted() {
    await this.refresh();
  },
  methods: {
    async refresh() {
      try {
        this.$store.commit("showLoader", true);
        await this.$store.dispatch("globalConfiguration/show");
        // this.form.freeTestUpperTeeth =
        //   this.configuration.freeTestUpperTeeth ?? "";
        // this.form.freeTestLowerTeeth =
        //   this.configuration.freeTestLowerTeeth ?? "";
        this.form.freeCases = this.configuration?.freeCases ?? "";
        this.form.salesPartnerFreeCases =
          this.configuration?.salesPartnerFreeCases ??
          this.configuration?.toothCreditsCost ??
          "5";
        this.form.redirectUrlAfterRegistration = this.configuration?.redirectUrlAfterRegistration ?? "";
        this.form.redirectUrlAfterMailVerification = this.configuration?.redirectUrlAfterMailVerification ?? "";
        this.bridgeUpperJaw = this.configuration?.bridgeUpperJaw ?? "";
        this.bridgeLowerJaw = this.configuration?.bridgeLowerJaw ?? "";
        this.crownUpperJaw = this.configuration?.crownUpperJaw ?? "";
        this.crownLowerJaw = this.configuration?.crownLowerJaw ?? "";

        this.originalForm = JSON.stringify(this.form);
      } catch (e) {
        console.error("api error ___", e);
      } finally {
        this.$store.commit("showLoader", false);
      }
    },
    handlePreviewClick(jawType) {
      const jaws = {
        bridgeUpper: this.bridgeUpperJaw,
        bridgeLower: this.bridgeLowerJaw,
        crownUpper: this.crownUpperJaw,
        crownLower: this.crownLowerJaw,
      };
      this.showJaw = jaws[jawType];
      this.previewJawType = jawType.endsWith("Upper") ? "upper" : "lower";
      this.showPreviewModal = true;
    },
    deleteFile(type) {
      this.form[`${type}Jaw`] = null;
      this.$refs[`${type}Input`].value = null;
    },
    addFile(event, type) {
      this.form[`${type}Jaw`] = event.target.files[0];
    },
    async save() {
      this.$refs.simpleRules.validate().then(async (success) => {
        if (success) {
          this.$store.commit("showLoader", true);
          const filePayload = {};
          const jawFields = [
            { formKey: "bridgeUpperJaw", ref: "bridgeUpperInput", extKey: "bridgeUpperExtension" },
            { formKey: "bridgeLowerJaw", ref: "bridgeLowerInput", extKey: "bridgeLowerExtension" },
            { formKey: "crownUpperJaw", ref: "crownUpperInput", extKey: "crownUpperExtension" },
            { formKey: "crownLowerJaw", ref: "crownLowerInput", extKey: "crownLowerExtension" },
          ];

          try {
            for (const field of jawFields) {
              if (this.form[field.formKey] && this.form[field.formKey].name) {
                const response = await this.handleFileUpload(
                  this.form[field.formKey],
                  { visibility: 1 },
                  0,
                  0.33
                );

                if (!response?.data[0]?.id) {
                  return;
                } else {
                  filePayload[field.formKey] = response.data[0].id;
                  filePayload[field.extKey] = response.data[0].type;
                }
              }
            }

            const {
              bridgeUpperJaw,
              bridgeLowerJaw,
              crownUpperJaw,
              crownLowerJaw,
              ...rest
            } = this.form;

            await this.$store.dispatch("globalConfiguration/saveRegistration", {
              ...rest,
              ...filePayload,
            });

            jawFields.forEach((field) => {
              this.form[field.formKey] = {};
              this.$refs[field.ref].value = null;
            });
            this.isFormDirty = false;
            this.originalForm = JSON.stringify(this.form);
            await this.refresh();
          } catch (e) {
            console.error("api error ___", e);
          } finally {
            this.$store.commit("showLoader", false);
          }
        }
      });
    },
  },
};
</script>
